import React, { forwardRef, useImperativeHandle, useRef, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import TaskDetailDrawer from '@/common/components/business/ExpandStore/TaskDetailDrawer';
import CircleTaskDetailDrawer from '@/views/expandstore/pages/expansioncircletask/components/Detail';
import SemirTaskDetailDrawer from '@/views/expandstore/pages/expansioncirclesenmatask/components/Detail';
import ExpansionFranchiseeCircleTaskDrawer from '@/views/expandstore/pages/expansionFranchiseeCircleTask/pages/detail/Drawer';

/**
 * @Description 自动适配各种拓店任务模板下的详情
 *
 * 用法
 *
 * import AdaptiveTaskDetail from '@/common/components/business/ExpandStore/AdaptiveTaskDetail';
 *
 * const detailRef: any = useRef(null);
 *
 *    <AdaptiveTaskDetail
        ref={detailRef}
        hideOperate={true}
        reload={() => methods.refreshCurrentPage()}
      />

    handleTaskDetail(record: any) {
      (detailRef.current as any).handleTaskDetail(record.id);
    }
 *
 */
const AdaptiveTaskDetail: React.FC<{
  isHistory?: boolean;
  hideOperate?: boolean;
  hideClusterDetail?: boolean;
  reload?: Function;
  ref: any;
}> = forwardRef(({
  isHistory = false,
  hideOperate = false,
  hideClusterDetail = false,
  reload
}, ref) => {
  useImperativeHandle(ref, () => ({
    handleTaskDetail
  }));

  const tenantCheckData = useSelector((state: any) => state.common.tenantCheck);

  const taskTemplateCode = useMemo(() => {
    return tenantCheckData?.taskTemplateCode || '';
  }, [tenantCheckData]);

  const detailRef: any = useRef();
  const [taskVisible, setTaskVisible] = useState<boolean>(false); // 拓店任务
  const [curTaskId, setCurTaskId] = useState<number>(0);

  const handleTaskDetail = (taskId: number) => {
    if (!taskTemplateCode || !taskId) return;
    if (taskTemplateCode === 'standardAndClusterA') { // 如果是加盟+直营的
      detailRef.current?.init(taskId);
    } else if (taskTemplateCode) {
      setCurTaskId(taskId);
      setTaskVisible(true); // 显示弹窗
    }
  };

  return (
    <>
      {/* 拓店任务 */}
      {taskTemplateCode === 'standardA' && <TaskDetailDrawer
        id={curTaskId}
        open={taskVisible}
        setOpen={setTaskVisible}
        isHistory={isHistory}
        hideOperate={hideOperate}
        outterRefresh={reload}
      />}
      {/* 直营模板 */}
      {['clusterA', 'clusterB'].includes(taskTemplateCode) && <CircleTaskDetailDrawer
        id={curTaskId}
        open={taskVisible}
        setOpen={setTaskVisible}
        isHistory={isHistory}
        hideOperate={hideOperate}
        hideClusterDetail={hideClusterDetail}
        outterRefresh={reload}
      />}
      {/* 森马模板 */}
      {taskTemplateCode === 'clusterC' && <SemirTaskDetailDrawer
        id={curTaskId}
        open={taskVisible}
        setOpen={setTaskVisible}
        isHistory={isHistory}
        hideOperate={hideOperate}
        hideClusterDetail={hideClusterDetail}
        outterRefresh={reload}
      />}
      {/* 加盟+直营模板A */}
      {taskTemplateCode === 'standardAndClusterA' && <ExpansionFranchiseeCircleTaskDrawer
        ref={detailRef}
        isHistory={isHistory}
        hideOperate={hideOperate}
        hideClusterDetail={hideClusterDetail}
        reload={reload}
      />}
    </>
  );
});

export default AdaptiveTaskDetail;
